import { Controller } from "stimulus";
import dispatchCustomEvent from "../functions/dispatchCustomEvent.js";

/*
 * Use this controller to emit further events to the document when there
 * is a succesful ajax event at the document level.
 * 
 * For example, when a form is successfully submitted, you may want to reload
 * a number of different elements on the page. 
 *
 * Set these as 'data-ajax-request-success-events'
 */

export default class extends Controller {
  dispatchAjaxSuccessEvents() {
    this.successEvents.forEach(function (eventName) {
      dispatchCustomEvent(document, eventName);
    });
  }

  get successEvents() {
    if (!this.element.dataset.ajaxRequestSuccessEvents) {
      return [];
    }

    return this.element.dataset.ajaxRequestSuccessEvents.split(" ");
  }
}
